import {
  loadProductsRegistry,
  loadProducts,
  getProductRegistryErrors,
  CARD_PRODUCT,
} from '@americanexpress/product-ducks';
import { applicationError } from '@americanexpress/one-app-ducks';
import dataRouter from '../routers/dataRouter';
import errorRouter from '../routers/errorRouter';
import redirect from './redirect';
import getMergedDest from './getMergedDest';
import getProductFromRegistryData from './getProductFromRegistryData';

export default function requireAuth(store, tenantLoginUrl, useGlobalLogin) {
  const { dispatch, getState } = store;
  // const locale = getState().getIn(['intl', 'activeLocale']);

  return (nextState, replace, callback) => dispatch(loadProductsRegistry())
    .then((productsRegistry) => {
      if (!global.BROWSER) {
        return callback();
      }
      const {
        selectedProduct,
        [CARD_PRODUCT]: cardProductsList,
      } = productsRegistry;
      const state = getState();
      const {
        cardError,
        customerError,
      } = getProductRegistryErrors(state);
      if (cardError) {
        throw cardError;
      }

      if (!selectedProduct && customerError) {
        throw customerError;
      }
      return dispatch(loadProducts())
        .then(() => {
          const newState = getState();
          const {
            details,
            registry,
          } = getProductFromRegistryData(newState, selectedProduct, cardProductsList);
          const { redirectUrl, redirectFunc } = dataRouter({
            locale: state.getIn(['intl', 'activeLocale']),
            state,
            route: nextState.location.pathname,
            productsOrder: cardProductsList,
            productsRegistry,
            opaqueAccountId: selectedProduct,
            registry,
            details,
          });
          if (redirectFunc) {
            return redirectFunc();
          }
          if (redirectUrl) {
            return redirect({ destination: redirectUrl, callback, replace });
          }
          return callback();
        });
    })
    .catch((error) => {
      const { body } = error;
      if (body) {
        // content-type is missing in response header which results in string
        // https://stash.aexp.com/stash/projects/ONE/repos/iguazu-rest/browse/src/actions/executeFetch.js?at=refs%2Ftags%2Fv1.7.0#36
        const bodyJSON = typeof body === 'string' ? JSON.parse(body) : body;
        const state = getState();
        const loginOpts = { tenantLoginUrl, useGlobalLogin };
        const mergedDest = getMergedDest(state, nextState, loginOpts);
        const { redirectUrl } = errorRouter({
          error,
          body: bodyJSON,
          state,
          dest: mergedDest,
          locale: state.getIn(['intl', 'activeLocale']),
          loginOpts,
        });

        if (redirectUrl) {
          return redirect({ destination: redirectUrl, callback, replace });
        }
        return Promise.reject(error);
      }
      return Promise.reject(error);
    })
    .catch((error) => {
      const state = getState();
      const correlationID = (error.response && error.response.headers
        && error.response.headers.correlation_id) || null;
      dispatch(applicationError('500', error, {
        dependencyId: 'axp-doc-communications-root',
        correlationID,
        publicGUID: state.getIn(['browser', 'cookies', 'blueboxpublic']),
      }));
      replace(`${nextState.location.pathname}/error`);
      return callback();
    });
}
